/*
  Black Toptan ön sipariş sepet kuralı (23 Eki 2026) — perakendedeki assets/preorder-cart.js ile aynı kural.
  Ön sipariş tarihi (custom.on_siparis_tarihi) gelmemiş ürün sepetteyken sepete yalnız aynı ürünün
  başka renk/serileri eklenebilir; normal ürün ya da başka bir ön sipariş ürünü eklenemez.
  Normal ürün varken ön sipariş ürünü eklenemez. Uyumsuz sepette ödeme düğmesi kapanır.
  Seri ekleme betiği (wholesale-quantity-multiplier) satır özelliklerini sildiği için durum
  sepetteki ürünün kendi tarihinden okunur: /products/<handle>?view=bf-onsiparis (snippets/bf-onsiparis).
*/
(function () {
  if (window.__bfOnSiparis) return;
  window.__bfOnSiparis = true;

  var EN = false;
  try { EN = String((window.Shopify && Shopify.locale) || '').toLowerCase().indexOf('en') === 0 || /^\/en(\/|$)/i.test(location.pathname); } catch (e) {}
  var S = EN ? {
    karisikNormal: 'This is a pre-order product with a different delivery time. Your cart contains regular products, so they cannot be ordered together. Please complete your current order first or remove the regular products.',
    farkliOnSiparis: 'This is a pre-order product. Your cart already contains another pre-order product with a possibly different delivery date. Each pre-order product must be ordered separately.',
    normalOnSiparisVar: 'Your cart contains a pre-order product. Pre-order products are ordered separately, so this product cannot be added to the same cart. Please complete or remove the pre-order first.',
    notOnSiparis: 'This pre-order product cannot be ordered together with the products in your cart.',
    notNormal: 'Your cart contains a pre-order product, so this product cannot be added to the same cart.',
    odemeCakisma: 'Your cart contains products that cannot be ordered together. Pre-order products must be ordered separately from other products. Please edit your cart to continue to checkout.'
  } : {
    karisikNormal: 'Bu bir ön sipariş ürünüdür ve teslim süresi diğer ürünlerden farklıdır. Sepetinizde normal ürünler bulunduğu için birlikte sipariş edilemez. Lütfen ön sipariş ürününü ayrı sipariş edin: mevcut sepetinizi tamamlayın ya da sepetinizdeki normal ürünleri çıkarın.',
    farkliOnSiparis: 'Bu bir ön sipariş ürünüdür. Sepetinizde farklı bir ön sipariş ürünü var ve teslim tarihleri farklı olabilir. Her ön sipariş ürünü ayrı sipariş edilmelidir. Bu ürünü eklemek için önce diğer ön sipariş ürününü sepetten çıkarın.',
    normalOnSiparisVar: 'Sepetinizde bir ön sipariş ürünü var. Ön sipariş ürünleri farklı teslim süresine sahip olduğundan ayrı sipariş edilir; bu ürünü aynı sepete ekleyemezsiniz. Önce ön sipariş siparişinizi tamamlayın ya da ön sipariş ürününü sepetten çıkarın.',
    notOnSiparis: 'Bu ön sipariş ürünü, mevcut sepetinizdeki ürünlerle birlikte sipariş edilemez.',
    notNormal: 'Sepetinizde ön sipariş ürünü olduğu için bu ürün aynı sepete eklenemez.',
    odemeCakisma: 'Sepetinizde birlikte sipariş edilemeyecek ürünler var. Ön sipariş ürünleri farklı teslim süresine sahip olduğundan diğer ürünlerle veya başka bir ön sipariş ürünüyle aynı sepette olamaz. Ödeme adımına geçmek için lütfen sepetinizi düzenleyin (ön sipariş ürününü ayrı sipariş edin).'
  };

  /* ---------- ürün durumu (handle → ön siparişte mi) ---------- */
  var SURE = 5 * 60 * 1000;
  var bellek = {};
  try { bellek = JSON.parse(sessionStorage.getItem('bf-onsiparis') || '{}') || {}; } catch (e) { bellek = {}; }
  function kaydet() { try { sessionStorage.setItem('bf-onsiparis', JSON.stringify(bellek)); } catch (e) {} }
  function durumYaz(h, onSiparis) { bellek[h] = { p: !!onSiparis, t: Date.now() }; }

  // Sayfadaki Liquid çıktısı en güncel bilgidir (form + sepet satırları)
  function sayfadanOku() {
    document.querySelectorAll('[data-bf-handle]').forEach(function (el) {
      var h = el.getAttribute('data-bf-handle');
      if (h) durumYaz(h, el.hasAttribute('data-bf-onsiparis'));
    });
  }

  function urunDurumu(h) {
    var b = bellek[h];
    if (b && Date.now() - b.t < SURE) return Promise.resolve(b.p);
    return fetch('/products/' + encodeURIComponent(h) + '?view=bf-onsiparis', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var p = false;
        try { p = JSON.parse(t.slice(t.indexOf('{'))).preorder === true; } catch (e) { p = false; }
        durumYaz(h, p); kaydet();
        return p;
      })
      .catch(function () { return b ? b.p : false; });
  }

  /* ---------- sepet durumu ---------- */
  var durum = null; // {onSiparis:[handle], normal:bool, adet:int}
  var iyimser = { onSiparis: [], normal: false, adet: 0 };

  function sepetiOku() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var hs = [];
        items.forEach(function (it) { if (it.handle && hs.indexOf(it.handle) < 0) hs.push(it.handle); });
        return Promise.all(hs.map(urunDurumu)).then(function (ps) {
          var on = [], normal = false;
          hs.forEach(function (h, i) { if (ps[i]) on.push(h); else normal = true; });
          return { onSiparis: on, normal: normal, adet: (cart && cart.item_count) || 0 };
        });
      });
  }

  function guncelDurum() {
    if (!durum) return null;
    var on = durum.onSiparis.slice();
    iyimser.onSiparis.forEach(function (h) { if (on.indexOf(h) < 0) on.push(h); });
    return { onSiparis: on, normal: durum.normal || iyimser.normal, adet: durum.adet + iyimser.adet };
  }

  function eklenebilir(ekHandle) {
    var s = guncelDurum();
    if (!s || s.adet === 0) return { ok: true };
    if (ekHandle) {
      if (s.normal) return { ok: false, mesaj: S.karisikNormal, not: S.notOnSiparis };
      if (s.onSiparis.some(function (h) { return h !== ekHandle; })) return { ok: false, mesaj: S.farkliOnSiparis, not: S.notOnSiparis };
      return { ok: true };
    }
    if (s.onSiparis.length) return { ok: false, mesaj: S.normalOnSiparisVar, not: S.notNormal };
    return { ok: true };
  }

  function cakisma() {
    var s = guncelDurum();
    if (!s) return false;
    return s.onSiparis.length >= 2 || (s.onSiparis.length >= 1 && s.normal);
  }

  /* ---------- bildirim ---------- */
  var bildirimZaman = null;
  function bildir(m) {
    if (!m) return;
    var el = document.querySelector('.bf-onsiparis-bildirim');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bf-onsiparis-bildirim';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = m;
    el.classList.add('is-acik');
    clearTimeout(bildirimZaman);
    bildirimZaman = setTimeout(function () { el.classList.remove('is-acik'); }, 5000);
  }

  /* ---------- ürün formları ---------- */
  function formHandle(pf) { return pf.getAttribute('data-bf-onsiparis') || null; }

  function formlaraUygula() {
    document.querySelectorAll('product-form[data-bf-handle]').forEach(function (pf) {
      var btn = pf.querySelector('[data-add-to-cart]');
      if (!btn) return;
      var k = eklenebilir(formHandle(pf));
      var not = pf.querySelector('.bf-onsiparis-engel');
      if (k.ok) {
        btn.classList.remove('bf-onsiparis-kapali');
        btn.removeAttribute('aria-disabled');
        if (not) not.remove();
      } else {
        btn.classList.add('bf-onsiparis-kapali');
        btn.setAttribute('aria-disabled', 'true');
        if (!not) {
          not = document.createElement('p');
          not.className = 'bf-onsiparis-engel';
          var form = pf.querySelector('form');
          (form || pf).appendChild(not);
        }
        if (not.textContent !== k.not) not.textContent = k.not;
      }
    });
  }

  /* ---------- sepet / ödeme ---------- */
  function sepeteUygula() {
    var c = cakisma();
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      b.classList.toggle('bf-onsiparis-kapali', c);
      if (c) {
        if (!b.hasAttribute('data-bf-kapatti')) { b.setAttribute('data-bf-kapatti', b.disabled ? 'zaten' : 'evet'); }
        b.setAttribute('aria-disabled', 'true'); b.disabled = true;
      } else if (b.hasAttribute('data-bf-kapatti')) {
        // yalnız bizim kapattığımızı aç (tema kendi kuralıyla kapattıysa dokunma)
        if (b.getAttribute('data-bf-kapatti') === 'evet') { b.disabled = false; b.removeAttribute('aria-disabled'); }
        b.removeAttribute('data-bf-kapatti');
      }
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) { el.classList.toggle('bf-onsiparis-gizli', c); });
    document.querySelectorAll('cart-items').forEach(function (ci) {
      var u = ci.parentNode && ci.parentNode.querySelector(':scope > .bf-onsiparis-uyari');
      if (c) {
        if (!u) {
          u = document.createElement('div');
          u.className = 'bf-onsiparis-uyari';
          u.setAttribute('role', 'alert');
          ci.parentNode.insertBefore(u, ci);
        }
        if (u.textContent !== S.odemeCakisma) u.textContent = S.odemeCakisma;
      } else if (u) { u.remove(); }
    });
  }

  function hepsi() { formlaraUygula(); sepeteUygula(); }

  /* ---------- yenileme ---------- */
  var yenileniyor = false, tekrar = false, zamanlayici = null;
  function yenile() {
    if (yenileniyor) { tekrar = true; return; }
    yenileniyor = true;
    sayfadanOku();
    sepetiOku().then(function (s) {
      durum = s;
      iyimser = { onSiparis: [], normal: false, adet: 0 };
      kaydet();
      hepsi();
    }).catch(function () {}).then(function () {
      yenileniyor = false;
      if (tekrar) { tekrar = false; yenile(); }
    });
  }
  function birazSonraYenile(ms) { clearTimeout(zamanlayici); zamanlayici = setTimeout(yenile, ms || 800); }

  /* ---------- yakalama ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.querySelector('button[name="checkout"]') || (e.submitter && e.submitter.name === 'checkout')) {
      if (cakisma()) { e.preventDefault(); e.stopImmediatePropagation(); bildir(S.odemeCakisma); }
      return;
    }

    var pf = form.closest('product-form[data-bf-handle]');
    if (!pf) return;
    var ek = formHandle(pf);
    var k = eklenebilir(ek);
    if (!k.ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      bildir(k.mesaj);
      formlaraUygula();
      return;
    }
    if (ek) { if (iyimser.onSiparis.indexOf(ek) < 0) iyimser.onSiparis.push(ek); }
    else iyimser.normal = true;
    iyimser.adet += 1;
    hepsi();
    birazSonraYenile(1500);
  }, true);

  ['cart:updated', 'cart:refresh', 'cart-updated', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { birazSonraYenile(400); });
  });
  window.addEventListener('pageshow', function () { yenile(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) yenile(); });

  // Sepet satırları yeniden çizilince (sepet sayfasında adet/kaldır) sepeti yeniden oku;
  // ürün formu yeniden çizilince (varyant değişimi) yalnız düğmeyi yeniden değerlendir (istek yok).
  // Kendi eklediğimiz öğelerin (.bf-onsiparis-*) değişimi yok sayılır — yoksa döngüye girer.
  function bizim(n) { return n && n.nodeType === 1 && /(^| )bf-onsiparis-/.test(n.className || ''); }
  var moZaman = null, moSepet = false;
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      var sepet = false, form = false;
      list.forEach(function (m) {
        var t = m.target;
        if (!t || t.nodeType !== 1 || bizim(t) || (t.closest && t.closest('[class*="bf-onsiparis-"]'))) return;
        var dugumler = [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes));
        if (dugumler.length && dugumler.every(function (n) { return bizim(n) || n.nodeType === 3 && t.closest && t.closest('[class*="bf-onsiparis-"]'); })) return;
        if (t.closest('cart-items') || (t.querySelector && t.querySelector('cart-items'))) sepet = true;
        else if (t.closest('product-form') || (t.querySelector && t.querySelector('product-form'))) form = true;
      });
      if (!sepet && !form) return;
      if (sepet) moSepet = true;
      clearTimeout(moZaman);
      moZaman = setTimeout(function () {
        sayfadanOku();
        if (moSepet) { moSepet = false; birazSonraYenile(300); } else formlaraUygula();
      }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', yenile);
  else yenile();
})();
